module.exports = __webpack_public_path__ + "static/media/glbl-01.652444e0.png";